export default "__VITE_ASSET__CXX4yyow__"